export default {
  methods: {
    $openMenu(selected, event, selectedIndex = null) {
      event.preventDefault();
      this.$refs["context-menu"].open(event, {
        selected,
        selectedIndex,
      });
    },
    $onCtxOpen(locals) {
      this.selected = locals.selected;
      this.selectedIndex = locals.selectedIndex;
    },
    $resetCtxLocals() {
      this.selected = null;
      this.selectedIndex = null;
    },
    // 右クリック行のハイライト解除。メニュー項目から確認ダイアログが開く場合は、ダイアログが閉じるまで維持する
    $onCtxCloseHighlight() {
      setTimeout(() => {
        if (!this.clearContextTarget) return;
        if (document.querySelector(".bootbox")) this.$waitDialogClose();
        else this.clearContextTarget();
      }, 0);
    },
    $waitDialogClose() {
      $(document).one("hidden.bs.modal", ".bootbox", () => {
        // 次のダイアログが遅れて開く操作(グループコピー等)を拾うため少し待つ
        setTimeout(() => {
          if (document.querySelector(".bootbox")) this.$waitDialogClose();
          else if (!this.$refs["context-menu"] || !this.$refs["context-menu"].ctxVisible) this.clearContextTarget();
        }, 400);
      });
    },
  },
};
